import { Spinner, Text } from '@chakra-ui/react';
import { type ReactNode } from 'react';
import { translate, type TranslationKey } from '../../../../constants/translation';
import { useDetectMobileScreenWidth } from '../../../../hooks/useDetectMobileScreenWidth';

interface Props<T> {
  results: T[];
  isLoading: boolean;
  headerTranslationKey: TranslationKey;
  subheaderTranslationKey?: TranslationKey;
  resultNodeFactory: (item: T) => ReactNode;
  noResultsMessage: ReactNode;
}

const SearchResults = <T,>({
  results,
  isLoading,
  headerTranslationKey,
  subheaderTranslationKey = null,
  resultNodeFactory,
  noResultsMessage,
}: Props<T>): JSX.Element => {
  const isMobile = useDetectMobileScreenWidth();
  const hasResult = !!results?.length;

  const headerText = isMobile ? null : (
    <Text className="message message-header text-md-medium">{translate(headerTranslationKey)}</Text>
  );

  const subheaderText =
    isMobile || !subheaderTranslationKey ? null : (
      <Text className="message message-subheader text-sm-regular">{translate(subheaderTranslationKey)}</Text>
    );

  const resultsList = (isLoading || hasResult) && (
    <div className="results-list">
      {hasResult && results.map(item => resultNodeFactory(item))}
      {isLoading && (
        <div className="loading-spinner">
          <Spinner />
        </div>
      )}
    </div>
  );

  return (
    <div key={headerTranslationKey}>
      {headerText}
      {subheaderText}
      {resultsList}
      {!isLoading && !hasResult && <>{noResultsMessage}</>}
    </div>
  );
};

export default SearchResults;
